// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"33c671c1","453":"e51c5d9e","948":"3e2c37f4"}[chunkId] + ".chunk.js";
};